











































import { Vue, Component, Prop } from 'vue-property-decorator'
import { TableList } from '@/shims-global'
import MainTitle from '../_components/MainTitle.vue'
import SubTitle from '../_components/SubTitle.vue'
import Page4Chart1 from '../_components/charts/Page4Chart1.vue'
import Page3Chart2 from '../_components/charts/Page3Chart2.vue'
@Component({
  components: {
    MainTitle,
    SubTitle,
    Page4Chart1,
    Page3Chart2
  }
})
export default class extends Vue {
  @Prop({}) private data!: any

  private list: Array < object > = [];
  created() {
    let obj: any = this.data.pie
    obj.name = obj.title
    obj.data = []
    obj.names = []
    obj.normData = []
    this.data.pie.dataList.map((v:any) => {
      obj.names.push(v.name)
      obj.data.push(v.value)
      obj.normData.push(v.normValue)
    })
    this.list.push(obj)
    this.data.syncBranchEnergyZoneVoLine.map(v => {
      this.list.push(v)
    })
  }
}
